export function HeroTagline({ a, b, c, className = "" }) {
  const fix = (s) => (typeof s === "string" ? s.replace("Ultimate Luxury", "Ultimate\u00a0Luxury") : s);
  return (
    <p className={`keep-italic mt-10 font-headline italic text-2xl lg:text-3xl leading-snug gold-text hero-tagline ${className}`} data-testid="hero-tagline">
      <span className="block">{fix(a)}</span><span className="block">{b}</span>{c && <span className="block">{c}</span>}
    </p>
  );
}

export default function PageTitle({ eyebrow, word, testid, className = "", eyebrowClass = "", children }) {
  return (
    <div className={className}>
      <p className={`eyebrow gold-text mb-10 ${eyebrowClass}`}>{eyebrow}</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight lg:whitespace-nowrap" data-testid={testid}>
        <span className="font-sign gold-text lowercase tracking-normal mr-3">the</span>{word}
      </h1>
      {children}
    </div>
  );
}
